export const DatabasesCheckMockData = [
  { organizationId: 'fc7c3553-d3ea-4538-9192-08db83c643a8', displayName: 'MockOrg1', isSuccess: true, error: '' },
  { organizationId: 'f24a232a-3034-4748-1137-08da025277fe', displayName: 'MockOrg2', isSuccess: false, error: 'MockError' },
];
